export class Utilities{
    static isEmpty(obj){
        return Object.keys(obj).length === 0;
    }

    static htmlDecode(input) {
        var doc = new DOMParser().parseFromString(input, "text/html");
        return doc.documentElement.innerHTML;
    }
}